import { sendCustomCommand as sendCommand } from 'console/redux/devices/items/actions';
import { capitalize } from 'lodash';
import { getButtonAction, getButtonCurrentLabel } from '../utils';
export function getLegacyCustomControls(device) {
    const { id: device_id, custom_controls, custom_controls_elements__loading, custom_controls_elements__fail, custom_controls_elements__fail_message, custom_controls_state, } = device;
    const shared_custom_controls = (custom_controls || []).map((custom_control, index) => {
        //Согласно спецификации на старые приборы, custom_control может содержать
        // ИЛИ команды,
        // ИЛИ статусы,
        // либо И команды И статусы
        const { commands, statuses } = custom_control;
        const control_status = statuses?.[0];
        const { id, type, active_if_status, name, title_if_status, active_value } = control_status || commands?.[0] || {};
        const capitalize_name = capitalize(name);
        //Соответственно аттрибут id из этих массивов означает РАЗНЫЕ элементы
        const state_value = control_status?.id != null
            ? custom_controls_state?.[control_status.id]
            : undefined;
        const control_value = state_value != null ? title_if_status?.[state_value] : undefined;
        const button_action = commands != null ? getButtonAction(commands, state_value) : null;
        const is_empty_action_name = button_action && !button_action.name;
        const current_label = is_empty_action_name
            ? ''
            : getButtonCurrentLabel(name ?? '', control_value);
        const action_label = button_action && button_action.name.length
            ? button_action.name
            : is_empty_action_name
                ? control_value
                : null;
        const is_active = active_if_status != null
            ? active_if_status === state_value
            : active_value != null
                ? state_value === Number(active_value)
                : !!state_value;
        const sendCustomCommand = button_action != null
            ? () => sendCommand(device_id, index, button_action.id)
            : undefined;
        const loading = custom_controls_elements__loading[index] ?? false;
        const fail = custom_controls_elements__fail[index] ?? false;
        const fail_message = custom_controls_elements__fail_message?.[index] ?? '';
        const _id = `${type}-${id}`;
        const additional_commands = (commands ?? []).map(({ name, id }) => ({
            title: name,
            action: () => sendCommand(device_id, index, id),
        }));
        return {
            id: _id,
            name: capitalize_name,
            sendCustomCommand,
            index,
            current_label,
            state_value,
            action_label,
            is_active,
            loading,
            fail,
            fail_message,
            additional_commands,
        };
    });
    return shared_custom_controls;
}
